import { render, staticRenderFns } from "./SettingsTabInfo.vue?vue&type=template&id=3f9275bc"
import script from "./SettingsTabInfo.vue?vue&type=script&lang=js"
export * from "./SettingsTabInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports